import * as React from 'react';
export const everySvg = React.forwardRef(function everySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('rect', {
      width: 512,
      height: 512,
      rx: 160,
      fill: '#EDE9E1',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm256.002 193.777-20.269-89.224-27.11 6.217 20.267 89.209c8.199-3.975 17.397-6.202 27.112-6.202Zm-60.911 48.807H104v27.937h91.085a63.136 63.136 0 0 1-1.565-13.969c0-4.803.553-9.473 1.571-13.968Zm-.006 27.941-82.063 39.706 12.065 25.17 82.065-39.708-56.793 71.552 21.74 17.42 56.785-71.542c-16.891-8.188-29.541-23.791-33.799-42.598Zm0-.004v.001-.001ZM303.38 110.77l-27.109-6.217-20.268 89.224c9.715 0 18.911 2.229 27.112 6.204l20.265-89.211Z',
      fill: '#010101',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm228.882 199.983-56.781-71.539-21.74 17.42 56.791 71.548-82.064-39.706-12.064 25.171 82.067 39.708c4.255-18.81 16.902-34.414 33.791-42.602Zm178.805 42.601H242.741v27.937H408v-27.937h-.313Z',
      fill: '#010101',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm386.918 177.708-82.07 39.71 56.794-71.554-21.74-17.42-56.781 71.541c16.891 8.188 29.541 23.792 33.797 42.601l82.067-39.707-12.067-25.171Zm-103.8 135.418 56.785 71.542 21.739-17.419-56.801-71.564c-5.822 7.327-13.233 13.325-21.723 17.441Zm-27.117 6.202c-9.714 0-18.91-2.227-27.11-6.202l-20.266 89.209 27.108 6.216 20.268-89.223 20.27 89.225 27.108-6.218-20.266-89.209c-8.202 3.975-17.398 6.202-27.112 6.202Z',
      fill: '#010101',
    }),
  );
});
everySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 512 512',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var every = {
  category: 'brand',
  colorable: false,
  name: 'every',
  svg: everySvg,
};
